import React from "react";
export var CustomVideoPlayer = function CustomVideoPlayer(props) {
  var uri = props.uri,
      vttUrl = props.vttUrl,
      ks = props.ks,
      thumbnailConfig = props.thumbnailConfig;

  var _ref = thumbnailConfig || {},
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 650 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 325 : _ref$height;

  return /*#__PURE__*/React.createElement("video", {
    poster: "".concat(props.thumbnailurl, "/width/").concat(width, "/height/").concat(height, "/quality/100"),
    src: "".concat(uri, "/ks/").concat(ks),
    crossOrigin: "anonymous",
    controlsList: "nodownload"
  }, /*#__PURE__*/React.createElement("track", {
    src: vttUrl ? vttUrl.replace(/(caption_captionasset)/, "/$1/ks/".concat(ks)) : "",
    kind: "captions",
    "default": true
  }));
};